import styled from "styled-components";

export const OrgChartContainer = styled.div`
  width: 100%;
  padding: 15px 10px;
  overflow-x: auto;
  overflow-y: auto;
  /* background-color: #f8f9fa; */
`;

export const OrgChartHeader = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  h3 {
    color: #203b34;
    font-size: 28px;
    font-weight: 600;
    margin: 0 0 8px 0;
  }

  p {
    color: #6c757d;
    margin: 0;
    font-size: 14px;
  }
  div {
    margin: 0;
    padding: 0;
    justify-content: left;
  }
`;

export const TreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  min-width: fit-content;
`;

export const NodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => (props.$level > 0 ? "40px" : "0")};
`;

export const EmployeeCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px 20px;
  margin: 8px 0;
  min-width: 400px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: ${(props) => (props.$hasChildren ? "pointer" : "default")};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  border-left: 4px solid
    ${(props) =>
      props.$isManager
        ? "#203b34"
        : props.$isEvaluator
        ? "#f9ae17"
        : "#e0e0e0"};

  &:hover {
    box-shadow: ${(props) =>
      props.$hasChildren
        ? "0 2px 8px rgba(0, 0, 0, 0.15)"
        : "0 1px 3px rgba(0, 0, 0, 0.1)"};
  }
`;

export const EmployeeAvatar = styled.div`
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 50%;
  background: ${(props) =>
    props.$isManager ? "#203b34" : props.$isEvaluator ? "#f9ae17" : "#6c757d"};
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
`;

export const EmployeeInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const EmployeeName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #212529;
  margin-bottom: 2px;
`;

export const EmployeeRole = styled.div`
  font-size: 14px;
  color: ${(props) =>
    props.$isManager ? "#203b34" : props.$isEvaluator ? "#f9ae17" : "#6c757d"};
  margin-bottom: 2px;
  font-weight: 500;
`;

export const EmployeeEmail = styled.div`
  font-size: 13px;
  color: #6c757d;
`;

export const CollapseButton = styled.button`
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 4px;
  background: transparent;
  color: #6c757d;
  border: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    border-color: #203b34;
    color: #203b34;
  }
`;

export const ChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  border-left: 2px solid #d1d1d1;
  padding-left: 20px;
  margin-top: 8px;
`;

export const ChildNode = styled.div`
  position: relative;
`;

export const ButtonAction = styled.button`
  background: #f9ae17;
  color: #fff !important;
  border: 1px solid #f9ae17;
  border-radius: 6px;
  padding: 3px 10px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;

  &:hover {
    background: #f9ae17a0;
    color: #ffffff;
    border: 1px solid #f9ae17a0;
    box-shadow: 0px 3px 6px #f9ae17;
  }
`;

export const ButtonClose = styled.button`
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  transition: all 0.2s ease;

  &:hover {
    color: #203b34;
    transform: scale(1.1);
  }
`;

export const Icon = styled.i`
  font-size: 13px;
  color: ${(props) => props.$color || "#203b34"};
`;

export const EmployeeCount = styled.div`
  background: #f9ae17;
  color: #ffffff;
  border-radius: 12px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
`;

export const EmployeeCount2 = styled.div`
  background: #203b34;
  color: #ffffff;
  border-radius: 12px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
`;

export const LabelText = styled.span`
  font-weight: 600;
  margin-right: 8px;
`;

export const ValueText = styled.span`
  color: #666;
`;

export const Subtitle = styled.h4`
  color: #203b34;
  font-weight: 600;
  margin-top: 16px;
  margin-bottom: 8px;
`;

export const AutoLabel = styled.span`
  display: inline-block;
  margin-right: 8px;
`;

export const AutoIcon = styled.i`
  font-size: 14px;
  color: #203b34;
`;

export const AutoValue = styled.span`
  font-weight: 500;
`;

export const ContainerTooltip = styled.div`
  max-width: 200px;
  text-align: center;
`;

export const StatusLink = styled.a`
  color: #203b34;
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 4px 8px;
  border-radius: 6px;

  /* &:hover {
    background: #f8f9fa;
    color: #f9ae17;
    text-decoration: none;

    i {
      transform: translateX(3px);
    }
  } */

  i {
    font-size: 12px;
    transition: transform 0.2s ease;
  }
`;

export const BreadcrumbDiv = styled.div`
  margin: 0 !important;
  padding: 0 !important;

  .row {
    margin: 0 !important;
    justify-content: flex-start !important;
  }

  .breadcrumb {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
  }

  .breadcrumb-item {
    margin: 0 !important;
    padding: 0 !important;
  }
`;
